module.exports = ".align-buttons {\n  text-align: right; }\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/master/master-compliance-indicator-maintenance/master-compliance-indicator-maintenance.component.scss
// module id = ./src/app/master/master-compliance-indicator-maintenance/master-compliance-indicator-maintenance.component.scss
// module chunks = main